import { motion, AnimatePresence } from 'motion/react';
import Currency from '../utils/Currency.js';

export function FloatingCartNotice({
  currency,
  locale,
  cart,
  cartCount,
  onCheckout,
  total,
  logActivity
}) {
  if (cartCount === 0) return null;

  const handleCheckout = () => {
    if (onCheckout) {
      logActivity('floating-cart-notice', 'checkout-button', 'click', true, {cart_details: cart.details});
      onCheckout();
    }
  };

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0, y: 100 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: 100 }}
        transition={{ duration: 0.3, ease: 'easeOut' }}
        className="fixed bottom-[24px] left-0 right-0 z-51 px-[24px]"
      >
        <div className="max-w-screen-xl mx-auto h-[120px] bg-mid backdrop-blur-sm rounded-[50px] shadow-[0_-4px_15px_rgba(0,0,0,0.12)] flex items-center justify-between px-[40px]">
          <div className="flex items-center">
            <p className="a11y-cart-notice-text secondary-font-bold text-2xl font-['Poppins',sans-serif] pr-[25px]">
              Tienes {cartCount} {cartCount === 1 ? 'producto' : 'productos'} en tu carro
            </p>
          </div>
          <motion.button
            onClick={handleCheckout}
            className="a11y-pay-button cursor-pointer btn btn-primary btn-lg h-[100px] px-[60px] rounded-[40px] shadow-[0_2px_8px_rgba(0,0,0,0.12)] hover:bg-[#C62569] transition-colors flex items-center justify-center"
            whileTap={{ scale: 0.8 }}
            whileHover={{ scale: 1.05 }}
            animate={{ boxShadow: ['0px 0px 30px 0px var(--color-primary-glow)', '0px 0px 30px 15px var(--color-primary-glow)', '0px 0px 30px 0px var(--color-primary-glow)'] }}
            transition={{boxShadow: { delay: 0, duration: 2, repeat: Infinity, ease: 'linear' } }}
          >
            {/* SOK-09: el precio va en su propio span para que con "Letra grande" baje a una
                segunda línea más chica (index.css); sin el modo se ve igual que antes. */}
            <span className="a11y-pay-label text-3xl lh-24 font-bold">
              Pagar{total ? <> <span className="a11y-pay-price">({new Currency(currency, locale).format(total)})</span></> : null}
            </span>
          </motion.button>
        </div>
      </motion.div>
    </AnimatePresence>
  );
}
